import { useSuspenseQuery } from '@tanstack/react-query';
import {
  ConfigCustomFieldDto,
  configControllerGetPublicProductConfigQueryOptions,
  useConfigControllerGetPublicTenantConfig,
} from 'korint-sdk';

export const useCustomFieldConfigs = ({
  productId,
  entityType,
}: {
  productId: string;
  entityType: 'customer' | 'policy' | 'asset' | 'brokerageFirm';
}): ConfigCustomFieldDto[] => {
  const { data: tenantConfig } = useConfigControllerGetPublicTenantConfig();

  const { data: productConfig } = useSuspenseQuery(
    configControllerGetPublicProductConfigQueryOptions(productId),
  );

  if (entityType === 'brokerageFirm') {
    return tenantConfig?.brokerageFirmCustomFields ?? [];
  }

  if (entityType === 'customer') {
    return productConfig?.customerFields ?? [];
  }

  if (entityType === 'policy') {
    return productConfig?.policyFields ?? [];
  }

  if (entityType === 'asset') {
    return productConfig?.assetFields ?? [];
  }

  throw new Error(`Unknown entity type: ${entityType}`);
};
